import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import capitalize from '../../../stringUtils';
import './StatusTracking.scss';
var dateOptions = {
  weekday: 'short',
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  seconds: '2-digit',
  timeZone: 'UTC'
};
var tableHeaders = [{
  id: 'old_status',
  label: 'Old Status'
}, {
  id: 'new_status',
  label: 'New Status'
}, {
  id: 'change_reason',
  label: 'Change Reason'
}, {
  id: 'user_email',
  label: 'Updated By'
}, {
  id: 'created_at_with_time',
  label: 'Change Timestamp'
}];
var ariaSortValue = function ariaSortValue(currentOrder) {
  return currentOrder === 'desc' ? 'descending' : 'ascending';
};
var descendingComparator = function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) return -1;
  if (b[orderBy] > a[orderBy]) return 1;
  return 0;
};
var getComparator = function getComparator(order, orderBy) {
  return order === 'desc' ? function (a, b) {
    return descendingComparator(a, b, orderBy);
  } : function (a, b) {
    return -descendingComparator(a, b, orderBy);
  };
};
var stableSort = function stableSort(array, comparator) {
  var stabilized = array.map(function (el, index) {
    return [el, index];
  });
  stabilized.sort(function (a, b) {
    var order = comparator(a[0], b[0]);
    return order !== 0 ? order : a[1] - b[1];
  });
  return stabilized.map(function (el) {
    return el[0];
  });
};
function StatusTracking(_ref) {
  var statusTracking = _ref.statusTracking;
  var _useState = useState('desc'),
    _useState2 = _slicedToArray(_useState, 2),
    order = _useState2[0],
    setOrder = _useState2[1];
  var _useState3 = useState('created_at_with_time'),
    _useState4 = _slicedToArray(_useState3, 2),
    orderBy = _useState4[0],
    setOrderBy = _useState4[1];
  var handleSort = function handleSort(property) {
    var isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "status-tracking-container table-responsive"
  }, /*#__PURE__*/React.createElement("table", {
    className: "table table-sm status-tracking-table",
    "aria-label": "status tracking"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, tableHeaders.map(function (th) {
    return /*#__PURE__*/React.createElement("th", {
      key: th.id,
      scope: "col",
      "aria-sort": orderBy === th.id ? ariaSortValue(order) : 'none'
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "status-tracking-sort-btn".concat(orderBy === th.id ? ' active' : ''),
      onClick: function onClick() {
        return handleSort(th.id);
      }
    }, th.label, /*#__PURE__*/React.createElement("span", {
      className: "sort-icon ms-1",
      "aria-hidden": "true"
    }, orderBy === th.id ? order === 'desc' ? '↓' : '↑' : '↕'), orderBy === th.id && /*#__PURE__*/React.createElement("span", {
      className: "visually-hidden"
    }, order === 'desc' ? ', sorted descending' : ', sorted ascending')));
  }))), /*#__PURE__*/React.createElement("tbody", null, stableSort(statusTracking, getComparator(order, orderBy)).map(function (row, index) {
    return /*#__PURE__*/React.createElement("tr", {
      key: "".concat(index, "-").concat(row.user_email)
    }, /*#__PURE__*/React.createElement("td", null, capitalize(row.old_status)), /*#__PURE__*/React.createElement("td", null, capitalize(row.new_status)), /*#__PURE__*/React.createElement("td", null, row.change_reason), /*#__PURE__*/React.createElement("td", null, row.user_email), /*#__PURE__*/React.createElement("td", null, new Date(row.created_at_with_time).toLocaleString('en-US', dateOptions)));
  }))));
}
StatusTracking.propTypes = {
  statusTracking: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
export default StatusTracking;